import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './shared/LoadingSpinner';

const decodeToken = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

const ProtectedRoute = ({ children, auth = null }) => {
  const { isAuthenticated, token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner size="lg" variant="pulse" fullScreen />;
  }

  if (!isAuthenticated || !token) {
    // Pass the page they tried to visit in state
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const payload = decodeToken(token);
  if (!payload || (payload.exp && payload.exp < Math.floor(Date.now() / 1000))) {
    return <Navigate to="/login" replace />;
  }

  const role_id = payload.role_id;
  if (auth !== null && (role_id === undefined || role_id > auth)) {
    // Authenticated but not staff (role_id >= 15). Blackbook is the only
    // thing these users can access, so land them there rather than on a
    // gated page (which would loop) or /login (a confusing dead-end).
    return <Navigate to="/blackbook" replace />;
  }

  return children;
};

export default ProtectedRoute;
